import type { FieldValues, FieldPath } from "react-hook-form";
import { FormField } from "./FormField";
import { SelectField } from "../ui/SelectField";
import type { SelectInputProps } from "../ui/SelectInput";

interface FormSelectFieldProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> extends Omit<SelectInputProps, "name" | "value" | "onChange" | "onBlur"> {
  name: TName;
  label?: string;
  optional?: boolean;
}

export function FormSelectField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({ name, label, optional, ...selectProps }: FormSelectFieldProps<TFieldValues, TName>) {
  return (
    <FormField
      name={name}
      render={({ value, onChange, onBlur, errorMessage, disabled }) => (
        <SelectField
          {...selectProps}
          name={name}
          label={label}
          optional={optional}
          value={value ?? ""}
          onChange={onChange}
          onBlur={onBlur}
          disabled={selectProps.disabled || disabled}
          errorMessage={errorMessage}
        />
      )}
    />
  );
}
